<template>
  <ThemeProvider>
    <!-- Global outage/degradation banner: polls a lightweight health signal and warns if the API or a
         critical subsystem is down. -->
    <DegradationBanner />
    <SidebarProvider>
      <AppShell />
    </SidebarProvider>
    <!-- Global re-auth prompt: surfaced by the api interceptor when an action needs sudo confirmation. -->
    <SudoDialog />
    <!-- Global transient toasts: optimistic-mutation failures and other one-off feedback. -->
    <ToastNotification />
  </ThemeProvider>
</template>

<script setup>
import ThemeProvider from './components/layout/ThemeProvider.vue'
import SidebarProvider from './components/layout/SidebarProvider.vue'
import AppShell from './components/layout/AppShell.vue'
import SudoDialog from './components/common/SudoDialog.vue'
import DegradationBanner from './components/common/DegradationBanner.vue'
import ToastNotification from './components/common/ToastNotification.vue'
</script>
